// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function insertElementIf(value: any, key: string) {
    return value ? { [key]: value } : {};
}
